import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BulkUpdateNoticesStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-update-notices",
})`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .errors-display-container {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
